module.exports = __webpack_public_path__ + "img/photo.487c4fba.png";